export { default as DynamicWidget } from "./dynamic_widget_container";
import * as DynamicWidgetFactory from "./dynamic_widget_factory";
import getResourceValue from "./get_resource_value";
export { default as WidgetEditDynamic } from "./dynamic_widget_form";

export { DynamicWidgetFactory, getResourceValue };
